import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#E3F3FD",
  d: "M2 3h6.5l1.219 2h8.531v12H2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#198FDE",
  fillRule: "evenodd",
  d: "M1 3.25a.7.7 0 0 1 .7-.7h6.54a.7.7 0 0 1 .486.197L10.2 4.174h8.1a.7.7 0 0 1 .7.7V16.75a.7.7 0 0 1-.7.7H1.7a.7.7 0 0 1-.7-.7zm1.4.7v12.1h15.2V5.574H9.916a.7.7 0 0 1-.487-.197L7.956 3.95z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#198FDE",
  fillRule: "evenodd",
  d: "M8.835 8.36a1.08 1.08 0 0 0-1.513 0 1.04 1.04 0 0 0 0 1.483 1.08 1.08 0 0 0 1.513 0 1.04 1.04 0 0 0 0-1.483m-2.287-.782a2.18 2.18 0 0 1 3.061 0c.85.84.85 2.206 0 3.047a2.18 2.18 0 0 1-3.061 0 2.14 2.14 0 0 1 0-3.047m6.39.943a.615.615 0 1 0-.869.87.615.615 0 0 0 .87-.87m-1.646-.778a1.715 1.715 0 1 1 2.425 2.425 1.715 1.715 0 0 1-2.425-2.425m2.377 4.313h-1.747a.55.55 0 1 1 0-1.1h1.747c.947 0 1.714.767 1.714 1.714a.55.55 0 1 1-1.1 0 .615.615 0 0 0-.614-.614m-7.208.595a.74.74 0 0 0-.744.73v.369a.55.55 0 1 1-1.1 0v-.368c0-1.017.83-1.832 1.844-1.832h3.235c1.013 0 1.844.815 1.844 1.832v.368a.55.55 0 1 1-1.1 0v-.368a.74.74 0 0 0-.744-.732z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=WorkspacesColorIcon20.js.map